import { Injectable } from "@angular/core";
import { AuthApi as RecruitmentAuthApi } from '../../../shared/recruitment/services/auth.api';
import { NestResponsesProvider } from '../../../shared/nestjs/nest-responses';

@Injectable()
export class ForgotPasswordRecruitmentBloc {

  constructor(
    private recruitmentAuthApi: RecruitmentAuthApi,
    private nestResponsesProvider: NestResponsesProvider,
  ) {

  }

  public async forgotPassword(email: string) {
    try {
        const register = await this.recruitmentAuthApi.forgotPassword(email).toPromise();
        return this.nestResponsesProvider.handleMsgError(register);
    } catch (error) {
        if (typeof error === 'string') {
            throw error;
        } else {
            throw this.nestResponsesProvider.handleMsgError(error);
        }
    }
  }

  public async resestPassword(password: string, passwordRe: string, key: string) {
    try {
        const register = await this.recruitmentAuthApi.resetPassword(password, passwordRe, key).toPromise();
        return this.nestResponsesProvider.handleMsgError(register);
    } catch (error) {
        if (typeof error === 'string') {
            throw error;
        } else {
            throw this.nestResponsesProvider.handleMsgError(error);
        }
    }
  }
}



// WEBPACK FOOTER //
// ./src/bloc/feature/forgot-password/forgot-password-recruitment.bloc.ts